export default {
    path: 'customer-service',
    name: 'customerService',
    component: () => import('@pages/customerService/CustomerServiceModule.vue'),
    children: [
        {
            path: 'chat',
            component: () => import('@pages/customerService/chat/ChatIndex.vue'),
            name: 'customerServiceChat',
        },
        {
            path: 'session-monitoring',
            component: () => import('@pages/customerService/sessionMonitoring/Index.vue'),
            name: 'sessionMonitoring',
        },
    ],
}
